import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../index.css";
import Images from "../Images";
import { AlignJustify, BarChart2, PlusCircle, ChevronDown, User, Store } from "lucide-react";

const TopNavbar = ({ setIsMenuOpen, isMenuOpen }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    const handleClickOutside = (event) => {
      if (!event.target.closest('.dropdown-container')) {
        setIsDropdownOpen(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    document.addEventListener("click", handleClickOutside);
    
    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const scrollToFAQ = () => {
    window.location.href = "/#faq";
  };

  return (
    <>
      <div
        className={`${
          isScrolled ? "bg-white shadow-md" : "bg-[#FFF4F1]"
        } w-full fixed top-0 left-0 right-0 z-50 transition-all duration-300`}
      >
        <div className="max-w-[1440px] mx-auto">
          <div className="flex justify-between items-center px-8 py-4">
            <div className="flex items-center">
              <Link to="/">
                <img src={Images.logo} alt="Dealboxx-Logo" />
              </Link>
            </div>
            <div
              className="flex justify-center items-center lg:hidden"
              onClick={toggleMenu}
            >
              <AlignJustify className="hover:text-[#FF6C6C] hover:transition ease-in-out duration-300 scale-105 hover:cursor-pointer" />
            </div>

            <nav className="hidden space-x-8 lg:flex">
              <Link to="/" className="text-black hover:text-gray-500">
                Home
              </Link>
              <Link
                to="/#faq"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToFAQ();
                }}
                className="text-black hover:text-gray-500"
              >
                FAQ
              </Link>
              <div className="relative dropdown-container">
                <button
                  onClick={toggleDropdown}
                  className="text-black hover:text-gray-500 flex items-center gap-1.5"
                >
                  Services
                  <ChevronDown size={18} className={`transform transition-transform ${isDropdownOpen ? 'rotate-180' : ''}`} />
                </button>
                {isDropdownOpen && (
                  <div className="absolute left-0 top-full z-50 py-2 mt-2 w-48 bg-white rounded-md shadow-lg">
                    <Link 
                      to="/analytics" 
                      className="flex items-center gap-1.5 px-4 py-2 text-black hover:bg-gray-100"
                    >
                      <BarChart2 size={18} /> 
                      Analytics
                    </Link>
                    <Link 
                      to="/createdeal" 
                      className="flex items-center gap-1.5 px-4 py-2 text-black hover:bg-gray-100"
                    >
                      <PlusCircle size={18} /> 
                      Create Deal
                    </Link>
                  </div>
                )}
              </div>
              <Link to="/support" className="text-black hover:text-gray-500">
                Support
              </Link>
            </nav>

            {/* Buttons */}
            <div className="hidden space-x-4 lg:flex">
              <button
                type="button"
                onClick={() => navigate("/signup")}
                className="flex gap-2 items-center px-5 py-2.5 font-semibold text-[#FF6F6E] bg-white border-2 border-[#FF6F6E] rounded-lg transition-all duration-300 ease-in-out hover:bg-[#FF6F6E] hover:text-white hover:shadow-xl hover:border-transparent transform hover:-translate-y-0.5"
              >
                <Store size={18} />
                Become a Vendor
              </button>
              <button
                type="button"
                onClick={() => navigate("/signin")}
                className="px-4 py-2 transition text-white duration-300 ease-in-out bg-[#FF6C6C] rounded-md hover:bg-[#f84242] hover:text-white flex items-center gap-2"
              >
                <User size={18} className="text-white" />
                Sign In
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TopNavbar;
